import React, {useState, useEffect, useRef, useContext} from 'react';
import { useTranslation } from "react-i18next";

const PuniPrazniKM = () => {
  const { t } = useTranslation();

    return(
        <div className="puniPrazniKM">
            Puni i Prazni KM
            {/* <Toast ref={toast}/>
            {load && <Loading/>}
            <div className="odrzavana_vozila">
                {unique.length > 0 ? unique.map((item, i)=>(
                        // eslint-disable-next-line react/jsx-pascal-case
                        <Serviced_vehicles
                        key={i}
                        largeData={serviceLogs}
                        data={item}
                        index={i}/>
                )): 'NEMA ODRZAVANIH VOZILA, NIŠTA NIJE ODRŽAVANO U SKORIJE VREME!!!'}
            </div> */}
        </div>
        
    )
}
export default PuniPrazniKM;